export const STAGE1_DESK_PUZZLE_POINTS = 100;
